export const newFormThemeOverrides = {
    MuiSelect: {
        styleOverrides: {
            outlined: {
                textAlign: 'right',
            },
        },
    },
}
